export default __webpack_public_path__ + "static/media/Pantalla_Laptop.d7722033.png";